import { gql } from "@apollo/client";

const INBOX_POST_ADDED = gql`
  subscription inboxpostadded {
    inboxpostadded {
      id
      post_id
      page_id
      agentId
      customerId
      message
      attachments
      created_time
      updated_time
      author_facebook_id
      author_name
      author_profile_picture
      total_comments_count
      last_seen_at
      closed_at
      customer_name
      customer_picture
      pageName
      accesstoken
    }
  }
`;

export default INBOX_POST_ADDED;
